import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Neighborhoodreview
const GQLAddNeighbourReview = gql`
  mutation addNeighbourReview(
    $NeighborhoodID: String
    $UserID: String
    $author: String
    $createDate: String
    $helpfulCount: Int
    $heading: String
    $description: String
    $communityRating: Float
    $publicSpacesRating: Float
    $curbAppealRating: Float
    $jobsRating: Float
    $keywords: String
    $greatfor: String
    $summary: String
    $editor_rate: Int
  ) {
    createneighborhoodreview(
      NeighborhoodID: $NeighborhoodID
      UserID: $UserID
      author: $author
      createDate: $createDate
      helpfulCount: $helpfulCount
      heading: $heading
      description: $description
      communityRating: $communityRating
      publicSpacesRating: $publicSpacesRating
      curbAppealRating: $curbAppealRating
      jobsRating: $jobsRating
      keywords: $keywords
      greatfor: $greatfor
      summary: $summary
      editor_rate: $editor_rate
    ) {
      success
      message
    }
  }
`;

//Update Neighborhoodreview
const GQLUpdateNeighbourReview = gql`
  mutation updateNeighbourReview($id: String!, $helpfulCount: Int) {
    Updateneighborhoodreview(id: $id, helpfulCount: $helpfulCount) {
      success
      message
    }
  }
`;

//Delete Neighborhoodreview
const GQLDeleteNeighbourReview = gql`
  mutation deleteNeighbourReview($id: String!, $neighborhoodid: String) {
    deleteneighborhoodreview(id: $id, neighborhoodid: $neighborhoodid) {
      success
      message
    }
  }
`;

const GQLHelpReview = gql`
  mutation helpReview(
    $reviewId: String
    $neighborhoodId: String
    $userId: String
    $helpStatus: Int
    $helpedDate: String
    $updatedDate: String
    $reviewuserId: String
  ) {
    helpReview(
      reviewId: $reviewId
      neighborhoodId: $neighborhoodId
      userId: $userId
      helpStatus: $helpStatus
      helpedDate: $helpedDate
      updatedDate: $updatedDate
      reviewuserId: $reviewuserId
    ) {
      success
      message
    }
  }
`;

//Get All User
const QUERY_getAllgetneighborhoodreviewList = gql`
  query getneighborhoodreview(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $auth_userId: String
  ) {
    getneighborhoodreview(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
      auth_userId: $auth_userId
    ) {
      id
      NeighborhoodID
      UserID
      author
      createDate
      helpfulCount
      heading
      description
      communityRating
      publicSpacesRating
      curbAppealRating
      jobsRating
      helpStatus
      userDetails {
        id
        type
        firstName
        lastName
        email
        password
        aboutMe
        numberNeighborhoodsReviewed
        likes
        questionsAnswered
        realEstateFirm
        points
        license
        phone
        aboutMe
        isagent
        ishomebuyer
        ishomeseller
        isneighbor
        istopagent
        userimage
        displayname
      }
      helpedUserId
      greatfor
      editor_rate
    }
  }
`;
const QUERY_editorrate = gql`
  mutation editorrate(
    $editor_rate: Int
    $neighborhoodId: String
    $reviewId: String
  ) {
    editorrate(
      editor_rate: $editor_rate
      neighborhoodId: $neighborhoodId
      reviewId: $reviewId
    ) {
      success
      message
    }
  }
`;

const QUERY_editreview = gql`
  mutation editreview(
    $description: String
    $neighborhoodId: String
    $reviewId: String
    $keywords: String
    $publicSpacesRating: Float
    $curbAppealRating: Float
  ) {
    editreview(
      description: $description
      neighborhoodId: $neighborhoodId
      reviewId: $reviewId
      keywords: $keywords
      publicSpacesRating: $publicSpacesRating
      curbAppealRating: $curbAppealRating
    ) {
      success
      message
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addneighborhoodreview(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddNeighbourReview,
        variables: {
          NeighborhoodID: adddata.NeighborhoodID,
          UserID: adddata.UserID,
          author: adddata.author,
          createDate: adddata.createDate,
          helpfulCount: adddata.helpfulCount,
          heading: adddata.heading,
          description: adddata.description,
          communityRating: adddata.communityRating,
          publicSpacesRating: adddata.publicSpacesRating,
          curbAppealRating: adddata.curbAppealRating,
          jobsRating: adddata.jobsRating,
          keywords: adddata.keywords,
          greatfor: adddata.greatfor,
          summary: adddata.summary,
          editor_rate: adddata.editor_rate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updateneighborhoodreview(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateNeighbourReview,

        variables: {
          id: updatedata.id,
          helpfulCount: updatedata.helpfulCount,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deleteneighborhoodreview(deletedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeleteNeighbourReview,
        variables: {
          id: deletedata.id,
          neighborhoodid: deletedata.neighborhoodid,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function helpreview(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLHelpReview,
        variables: {
          reviewId: adddata.reviewId,
          neighborhoodId: adddata.neighborhoodId,
          userId: adddata.userId,
          helpStatus: adddata.helpStatus,
          helpedDate: adddata.helpedDate,
          updatedDate: adddata.updatedDate,
          reviewuserId: adddata.reviewuserId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function editorrate(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: QUERY_editorrate,
        variables: {
          editor_rate: adddata.editor_rate,
          neighborhoodId: adddata.neighborhoodId,
          reviewId: adddata.reviewId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function editreview(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: QUERY_editreview,
        variables: {
          description: adddata.description,
          neighborhoodId: adddata.neighborhoodId,
          reviewId: adddata.reviewId,
          keywords: adddata.keywords,
          publicSpacesRating: adddata.publicSpacesRating,
          curbAppealRating: adddata.curbAppealRating,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllneighborhoodreview(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllgetneighborhoodreviewList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          auth_userId: getdata.auth_userId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addneighborhoodreview,
  updateneighborhoodreview,
  deleteneighborhoodreview,
  getAllneighborhoodreview,
  helpreview,
  editorrate,
  editreview,
};
